import React from 'react';
import { useTranslation } from 'react-i18next';

import { RefreshIcon } from '../icons';
import { Row, Left, LumioMark, Label, RefreshBtn, RefreshLabel } from './SuggestionsHeader.styles';

/* Same multicolour Lumio mark as the Lumio panel header + top bar (LumioChat
 * `LOGO_SRC`). A gradient asset, so it renders as a plain <img>, not a glyph. */
const LUMIO_MARK_SRC = '/assets/lumio/lumio-mark.svg';

export interface SuggestionsHeaderProps {
  /** Eyebrow copy (i18n key / literal) + interpolation values. */
  label: string;
  placeholders?: Record<string, string | number>;
  onRefresh: () => void;
}

/**
 * The "✦ Lumio's suggestions for …" eyebrow with a right-aligned orange "Refresh
 * suggestions" button. Shared by the name + domain sections (desktop & mobile).
 */
export const SuggestionsHeader = ({ label, placeholders, onRefresh }: SuggestionsHeaderProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <Row>
      <Left>
        <LumioMark src={LUMIO_MARK_SRC} alt="" />
        <Label text={label} placeholders={placeholders} tag="span" />
      </Left>
      <RefreshBtn type="button" onClick={onRefresh} aria-label={t('Refresh suggestions')}>
        <RefreshIcon size={18} />
        <RefreshLabel text="Refresh suggestions" tag="span" />
      </RefreshBtn>
    </Row>
  );
};

export default SuggestionsHeader;